// Find a location in the system identification slice by its name.
//
// Nothing guarantees the name is unique. It is `zone_name` straight off the
// server, and the only validation the form applies is the two-dash format —
// so two zones can legitimately carry the same name. The lookup this replaces
// scanned the whole array with no early exit and kept the LAST match, which
// meant a duplicate silently decided which site an edit merged into.
//
// Returning the count alongside the index lets the caller say something about
// an ambiguous merge rather than making it invisible. First match wins: with
// no duplicates it is the only match, and with duplicates it is at least a
// stable choice rather than an arbitrary one.
//
// A blank name never matches. handleLocationsSystemIdentification maps
// `zone_name || ''`, so every unnamed zone collapses to the same empty string
// and matching on it would merge unrelated sites together.
export const locationIdxByName = (locations, name) => {
  if (!name) {
    return { index: -1, matchCount: 0 };
  }

  let index = -1;
  let matchCount = 0;

  (locations ?? []).forEach((entry, idx) => {
    if (entry?.location !== name) return;

    matchCount += 1;
    if (index === -1) index = idx;
  });

  return { index, matchCount };
};

